
<style>

.card-grid-operators{
  margin: 32px !important;
}

</style>

<template>
  <div>
    <v-card class="card-grid-operators">
      <div>
        <grid
          newLabel="Aggiungi"
          :headers="headers"
          :CanCreate="true"
          title="Procedures"
          controller="GridElement/"
          readAll="GetProcedures"
          create="Create"
          edit="Create"
          delete="Procedures/DeleteProcedure"
          v-on:refreshMenu="updateMenu"
          :hideColumns="['Id']"/>
      </div>
    </v-card>
  </div>
</template>

<script>
import grid from "../../components/gridComponent.vue";

//nome api
//GetOperators

export default {

  components: {
    grid,
  },
  
  data () {
    return {
      headers: [
        { text: 'Nome', value: 'Name' },
        { text: 'Stored Procedure', value: 'StoredProcedure' },
      ],
    };
  },

methods: {
  updateMenu() {
      this.$emit("refreshMenu", true);
    }
}

}
</script>
